import { Container } from "@mui/material";
import { DataStoreBreadcrumbs } from "~/components/DataStoreBreadcrumbs";
import { LqsPage } from "~/lqs/layout";
import { LogDetails } from "./components/LogDetails";

export function LogPage() {
  return (
    <LqsPage title="Log Details">
      <Container fixed>
        <DataStoreBreadcrumbs />
        <LogDetails />
      </Container>
    </LqsPage>
  );
}
